import React from "react";

const NewCertificateIcon = ({ iconDropDownList,size, color }) => {
  return (
    <>
    <div className="dropdown">
      <a className="btn cert-icon btn-transparent-dark dropdown-toggle position-static noArrow" data-bs-toggle="dropdown">
    <svg
      fill={color}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 0.96 0.96"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
      version="1.1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsSerif="http://www.serif.com/"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d="M0.779 0.15A0.09 0.09 0 0 0 0.689 0.06H0.27A0.09 0.09 0 0 0 0.18 0.15v0.66a0.09 0.09 0 0 0 0.09 0.09h0.419a0.09 0.09 0 0 0 0.09 -0.09zm-0.06 0v0.66a0.03 0.03 0 0 1 -0.03 0.03H0.27A0.03 0.03 0 0 1 0.24 0.81V0.15A0.03 0.03 0 0 1 0.27 0.12h0.419a0.03 0.03 0 0 1 0.03 0.03" />
      <path d="M0.45 0.24H0.42a0.03 0.03 0 0 0 0 0.06h0.03v0.03a0.03 0.03 0 0 0 0.06 0v-0.03h0.03a0.03 0.03 0 0 0 0 -0.06h-0.03V0.21a0.03 0.03 0 0 0 -0.06 0z" />
      <path d="M0.33 0.51h0.3a0.03 0.03 0 0 0 0 -0.06H0.33a0.03 0.03 0 0 0 0 0.06" />
      <path d="M0.33 0.63h0.3a0.03 0.03 0 0 0 0 -0.06H0.33a0.03 0.03 0 0 0 0 0.06" />
      <path d="M0.33 0.75h0.3a0.03 0.03 0 0 0 0 -0.06H0.33a0.03 0.03 0 0 0 0 0.06" />
    </svg>
   </a>
          <div className="dropdown-menu dropdown-menu shadow" aria-labelledby="userDropdown">
        {iconDropDownList.map((list,listIndex)=>{
            const {label,clickHandler} = list;
            return(
                <div className="dropdown-item" key={listIndex} href="#" onClick={clickHandler} title={label}>{label}
                </div>
            )
        })}
      </div>
        </div>
      </>  
  );
};

NewCertificateIcon.defaultProps = {
  size: 20,
  color: "#5453D2",
};

export default NewCertificateIcon;


